import React from 'react';

import { ThemeProvider, CssBaseline } from '@mui/material';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { AWS_CONFIG } from './common/components/tfa-auth/config/config';
import { IAuthAWS } from './common/components/tfa-auth/interfaces/IAuthAWS';
import {
  IAuthFunctionalities,
  MFAType,
} from './common/components/tfa-auth/interfaces/IAuthFunctionalities';
import AuthModule from './common/components/tfa-auth/pages/AuthModule';
import { store, persistor } from './common/stores/rootStore';
import { theme } from './common/theme/theme';
import { AdminRoutes, FlorenceRoutes } from './routes';

const App = () => {
  const config: IAuthAWS = AWS_CONFIG;
  const authConfig: IAuthFunctionalities = {
    RememberDevice: false,
    MFA: MFAType.EMAIL,
  };

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AuthModule awsConfig={config} authConfig={authConfig}>
            {window.location.host.includes('admin') ? (
              <AdminRoutes />
            ) : (
              <FlorenceRoutes />
            )}
          </AuthModule>
          {/* <Footer /> */}
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
